import { connect } from 'react-redux';
import { push } from 'redux-first-history';
import { formatDate } from '@common/paymentsUtils/dateUtils';
import queryString from 'query-string';
import EditDueDateModal from './component';
import { DEFAULT_ERROR } from '@rental-manager/constants/NotificationConstants';
import { getLandlordStatus } from '@rental-manager/actions/requests';
import { editingRentTerms } from '@rental-manager/actions/DashboardActions';
import { closeNotification, showModalNotification } from '@common/actions/NotificationActions';
import { trackValidationError } from '@common/actions/TrackingActions';
import paths from '@rental-manager/pathsManifest';
import { logError } from '@zg-rentals/log-error';

const mapStateToProps = (state, ownProps) => {
  const rentTermsKeyFromQueryString = queryString.parse(ownProps.location.search).rentTermsKey;
  const { currentTerm, nextTerm } = state.payments.landlord.property;

  let rentTerm;
  if (rentTermsKeyFromQueryString && nextTerm?.rentTermsKey === rentTermsKeyFromQueryString) {
    rentTerm = nextTerm;
  } else if (rentTermsKeyFromQueryString && currentTerm?.rentTermsKey === rentTermsKeyFromQueryString) {
    rentTerm = currentTerm;
  }
  const { paymentDateForFirstMonth } = rentTerm;

  return {
    paymentDayOfTheMonth: Number(formatDate(paymentDateForFirstMonth, 'd')),
    rentTermsKey: rentTerm.rentTermsKey,
    user: state.user,
    currentProperty: state.payments.landlord.property.listingDetails,
  };
};

export const mapDispatchToProps = (dispatch, { baseUrl, propertyId }) => ({
  onSubmit: ({ paymentDayOfTheMonth, rentTermsKey }) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(editingRentTerms({ propertyId, paymentDayOfTheMonth })))
      .then(() =>
        dispatch(
          // TODO: fix this
          (push as any)(
            {
              pathname: baseUrl + paths.dashboard.editTermLengthPage,
              search: `rentTermsKey=${rentTermsKey}`,
            },
            { fromWhere: paths.dashboard.editDueDatePage },
          ),
        ),
      )
      .catch((err) => {
        logError({ error: err });
        dispatch(showModalNotification(DEFAULT_ERROR));
        return { error: true };
      }),
  onCancel: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(editingRentTerms({ propertyId, paymentDayOfTheMonth: null })))
      .then(() => dispatch(push(baseUrl))),
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(editingRentTerms({ propertyId, paymentDayOfTheMonth: null })))
      .then(() => dispatch(push(baseUrl)))
      .then(() => dispatch(getLandlordStatus({ propertyId }))),
  trackValidationError: (data) => dispatch(trackValidationError(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditDueDateModal);
